import ThemeService from "../api/theme.js"
import elasticlunr from 'elasticlunr'

import {deaccent} from '@/utils/text'

let index = elasticlunr(function () {
    this.setRef('id')
    this.addField('name')
    this.addField('year')
})

export const state = () => ({
    list: [],
    list_dict: [],
    list_results: [],
    list_loading: false,
    list_loaded: false,
    item: null,
    item_loading: false,
    recipients: [],
    recipients_loading: false
})


export const getters = {
    item(state) {
        return state.item;
    },
    list(state) {
        return state.list_results
    },
    list_dict(state) {
        return state.list_dict
    },
    list_loading(state) {
        return state.list_loading
    },
    recipients(state) {
        return state.recipients;
    },
    recipients_loading(state) {
        return state.recipients_loading;
    }
}

export const actions = {
    async fetch_list({commit, state}, params) {
        if (state.list_loading || state.list_loaded) {
            return;
        }

        commit('setListLoading', true)
        const data = ThemeService.all(params.locale)

        commit('setList', data)
        commit('setListLoading', false);
    },
    async fetch_recipients({commit, state}, params) {
        if (!params){
            return;
        }

        commit('setItemLoading', true);

        var nextModel;
        for (var i = 0; i < state.list.length; i++){
            var model = state.list[i];
            if (model.slug && params.slug === model.slug){
                nextModel = state.list[i];
            }
        }
        if (!nextModel){
            return;
        }

        commit('setItem', nextModel);
        commit('setRecipientsLoading', true);

        await ThemeService.recipients(params.locale, nextModel.search)
            .then((response) => {
                commit('setRecipients', response.data)
            })
            .catch((error) => {
                console.log(`Theme API Error => ${error}`)
            })
    },
    async clear_search({commit, state}, params) {
        commit('resetSearch')
        return
    },
    async null_item({commit}) {
        commit('setItem', null);
    },
    async search({commit, state}, q) {
        if(!q) {
            commit('resetSearch')
            return
        }
        commit('setSearchResults', index.search(deaccent(decodeURI(q)), {
            expand: true,
        }))
    }
}

export const mutations = {
    resetSearch(state) {
        state.list_results = state.list
    },
    setItem(state, data) {
        state.item = data
        state.item_loading = false
    },
    setItemLoading(state, data) {
        state.item_loading = data
    },
    setList(state, data) {
        let dict = {}
        data.forEach(item => {
            dict[item.name] = item.name
            index.addDoc({
                'id': item.id,
                'name': deaccent(item.name),
                'year': item.year,
            })
        })

        state.list = data
        state.list_dict = dict
        state.list_results = data
        state.list_loaded = true
    },
    setListLoading(state, loading) {
        state.list_loading = loading
    },
    setRecipients(state, data) {
        if(data) {
            state.recipients = "results" in data ? data["results"] : []
        } else {
            state.recipients = []
        }
        state.recipients_loading = false
    },
    setRecipientsLoading(state, loading) {
        state.recipients_loading = loading
    },
    setSearchResults(state, results) {
        const ids = results.map((result) => (
            parseInt(result.ref)
        ))
        state.list_results = state.list.filter((item) => (
            ids.includes(item.id)
        ))
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
